/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';

export default createSvgIcon(
  <svg viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.53 7.4698a.75.75 0 1 1 1.061 1.0604L2.8713 11.25h18.2574l-2.7197-2.7198a.75.75 0 0 1 1.061-1.0604L24 12l-4.53 4.5302a.75.75 0 0 1-1.061-1.0606l2.7197-2.7196H2.8713l2.7197 2.7198a.75.75 0 0 1-1.0607 1.0606L0 12l4.53-4.5302Z"
      clipRule="evenodd"
    />
  </svg>,
  'ArrowBidirectionalLong'
);
